/**
 * Created by rlopez on 10/11/16.
 */
// ConnectionDetailsView.js

import {View,Model} from 'backbone'
import GeneralView from 'dashboard/connections/connection-type/ConnectionGeneralView';
import ActionView from 'dashboard/connections/connection-type/ConnectionActionView';
import PermissionsView from '../../settings/PermissionsView';
import contentTemplate from 'dashboard/connections/connection-details-view.ejs';
import DetailViewFactory from 'dashboard/connections/DetailViewFactory';
import ConnectionOperationsView from 'dashboard/connections/connection-type/ConnectionOperationsView';
import ConnectionService from 'dashboard/connections/ConnectionService';
import ConnectionsHelpView from 'dashboard/connections/ConnectionsHelpView';
import ConnectionResearchView from 'dashboard/connections/details/ConnectionResearchView';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import constants from 'Constants.js';
import eventBus from 'EventBus.js';
import $ from 'jquery';
import listService from 'ListService';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import util from 'util/Util';

class ConnectionDetailsView extends View {

    initialize(opts) {
        this.opts = opts || {};
        this.template = contentTemplate;
    }

    render() {

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const connectionService = new ConnectionService({model:this.model});


        // PF-3075: attempt to mitigate Q/A automated test harness recording process hanging on Apply Changes button.
        // Hypothesis is that a stampede of five parallel UI repaints could cause a test recording failure.
        // The approach here: sequence the composite render calls to occur sequentially, each on a separate browser turn.
        //   - Each setTimeout yields to the next browser turn.
        //   - The promise resolution chain gates each subsequent render call to happen only after its predecessor render call returns.

        // Sequence each async call in-turn by returning the next promise in each then callback.
        // Each call advances on the resolve call.
        // The human cannot detect this serialization of rendering, but perhaps the test recorder can.
        new Promise( resolve => {
            window.setTimeout(() => {
                const generalView = new GeneralView({el:'#connectionGeneral', model:this.model, connectionService});
                generalView.render();
                resolve(true);
            },0 );
        }).then(() => { //PF-11037 Load sources for rest and soap services
            return new Promise(resolve => {
                window.setTimeout(() => {
                    const self = this;
                    const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
                    if (isBULicense && (self.model.get('connectionType') === constants.WEB_GROUP_TYPE || self.model.get('connectionType') === constants.REST_GROUP_TYPE)) {
                        connectionService.loadWSSources().then(()=>{
                            resolve(true);
                        });
                    }
                    else{
                        resolve(true);
                    }
                }, 0);
            });
        }).then(() => {
            return new Promise( resolve => {
                window.setTimeout(() => {
                    const actionView = new ActionView({el:'#connectionActions', model:this.model, connectionService});
                    actionView.render();
                    resolve(true);
                },0 );
            });
        }).then( () => {
            return new Promise( resolve => {
                window.setTimeout(() => {
                   // PF-8669
                    const permissionView = new PermissionsView({el:'#permissions', model:this.model, service: connectionService, detailsName: 'currentConnectionDetails'});
                    permissionView.render();
                    resolve(true);
                },0 );
            });
        }).then( () => {
            return new Promise( resolve => {
                window.setTimeout(() => {
                    
                    if (!this.opts.type && this.model && this.model.get('connectionType')){
                        this.opts.type = this.model.get('connectionType');
                    }

                    const detailView = DetailViewFactory.getConnectionDetailView(this.opts.type, {el:'#connectionDetails', model:this.model, connectionService});
                    detailView.render();
                    resolve(true);
                },0 );
            });        
        }).then( () => {
            return new Promise( resolve => {
                window.setTimeout(() => {
                    // const connectionsHelpView = new ConnectionsHelpView({el: '#connectionsHelp', model:this.model, connectionService});
                    // connectionsHelpView.render();
                    resolve(true);
                },0 );
            });
        }).then( () => {
            const self = this;
            window.setTimeout(() => {
                if(self.model.get('connectionType') && self.model.get('connectionType') === constants.GOOGLE_GROUP_TYPE){
                    const connectionResearchView = new ConnectionResearchView({el:'#connectionResearch', model:self.model });
                    connectionResearchView.render();
                }
            },0 );
        }).then( () => {
            return new Promise( resolve => {
                window.setTimeout(() => {

                    const ownerId = this.model.get("connectionDetails").OwnerId;                    
                    const currentUserId = listService.accountSettings.UserId;

                    const isOwner = ownerId === currentUserId;
                    this.model.set("isOwner", isOwner, {silent:true});

                    const actionsControlView = new ConnectionOperationsView({el: '#actionsControlView', model:this.model, connectionService});
                    actionsControlView.render();
                    resolve(true);
                },50 );
            });
        });

        $('#goToConnections').on('click', this.goToConnections);
    }

    goToConnections(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadConnectionsView");
    }

    refresh(){
        if(this.model.get('hasChanges')){

            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`Connection - ${this.model.get("connectionDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    // Find current report ID
                    eventBus.trigger(constants.EV_REFRESH_CONNECTION_DETAILS, this.model.get('connectionId'),this.model.get('connectionType'));
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_DETAILS, this.model.get('connectionId'),this.model.get('connectionType'));
        }
    }
}

export default ConnectionDetailsView;

